// Service
import AccountsService from '../../services/accounts.service';
// Reducer
import * as AccountsReducer from './accounts.reducers';

// Utilities

import { setOpenAccountAndProductData, setOpenAccountAndProductDataExistingClient } from '../../utilities/helper-functions';

// Consult if the client has a Current Account ====================================================================================================

export const consultaCuentaCorriente = (data) => async (dispatch) => {
  dispatch(AccountsReducer.setConsultIfClientHasCurrentAccountLoading());

  try {

    await AccountsService.consultaCuentaCorriente(data);
    dispatch(AccountsReducer.setConsultIfClientHasCurrentAccountSuccess(false));

  } catch (error) {
    if (error.response?.data?.data?.codigoError === "1") {
      dispatch(AccountsReducer.setConsultIfClientHasCurrentAccountSuccess(true));
    } else {
      dispatch(AccountsReducer.setConsultIfClientHasCurrentAccountFailure(error.response?.data?.data?.descripcionError || error.message));
    }
  }

}


// Consult if the client has a Current Account ====================================================================================================

export const consultaProductoActivo = (data) => async (dispatch) => {
  dispatch(AccountsReducer.setConsultIfClientHasActiveProductsLoading());

  try {
    await AccountsService.consultaProductoActivo(data);
    dispatch(AccountsReducer.setConsultIfClientHasActiveProductsSuccess(false));
  } catch (error) {
    if (error.response?.data?.data?.codigoError === "1") {
      dispatch(AccountsReducer.setConsultIfClientHasActiveProductsSuccess(true));
    } else {
      dispatch(AccountsReducer.setConsultIfClientHasActiveProductsFailure(error.response?.data?.data?.descripcionError || error.message));
    }
  }

}


// Clear Consult if the client has a Current Account Store ====================================================================================================

export const clearConsultaProductoActivoStore = () => async (dispatch) => {
  dispatch(AccountsReducer.clearconsultIfClientHasActiveProductsStore());
}


// Open Account ====================================================================================================

// export const aperturaCuentas = (data, userId, addressId) => async (dispatch) => {
//   dispatch(AccountsReducer.setOpenAccountLoading());

//   try {
//     if (!Array.isArray(data.productFunds) || data.productFunds.length === 0) {
//       return dispatch(AccountsReducer.setOpenAccountFailure("No hay productos seleccionados"));
//     }

//     const openAccountPromise = data.productFunds.map(product => {
//       let formatedData = setOpenAccountAndProductData(data, userId, addressId, product);
//       return AccountsService.aperturaCuentas(formatedData);
//     });

//     await Promise.all(openAccountPromise);
//     dispatch(AccountsReducer.setOpenAccountSuccess());

//   } catch(error) {
//     dispatch(AccountsReducer.setOpenAccountFailure(error.response?.data?.data?.descripcionError || error.message));
//   }

// }

export const aperturaCuentas = (data, userId, addressId) => async (dispatch, getState) => {
  dispatch(AccountsReducer.setOpenAccountLoading());

  try {
    if (!Array.isArray(data.productFunds) || data.productFunds.length === 0) {
      return dispatch(
        AccountsReducer.setOpenAccountFailure("No hay productos seleccionados")
      );
    }

    const { successfulProducts } = getState().accounts.openAccount;

    for (const product of data.productFunds) {
      if (successfulProducts.includes(product.idDelProducto)) {
        continue;
      }

      dispatch(
        AccountsReducer.setOpenAccountCurrentProduct(product.nombreProducto)
      );

      const formatedData = setOpenAccountAndProductData(
        data,
        userId,
        addressId,
        product
      );

      await AccountsService.aperturaCuentas(formatedData);

      dispatch(
        AccountsReducer.setAddOpenAccountSuccessfulProduct(product.idDelProducto)
      );
    }

    dispatch(AccountsReducer.setOpenAccountSuccess());

  } catch (error) {
    dispatch(
      AccountsReducer.setOpenAccountFailure(
        error.response?.data?.data?.descripcionError || error.message
      )
    );
  }
};

// Open Account Existing Client ====================================================================================================

export const aperturaCuentasClienteExistente = (data, userId, address) => async (dispatch) => {
  dispatch(AccountsReducer.setOpenAccountLoading());

  try {

    const openAccountPromise = data.productFunds.map(async product => {
      let formatedData = setOpenAccountAndProductDataExistingClient(data, userId, address, product);

      await AccountsService.aperturaCuentas(formatedData);
    });

    await Promise.all(openAccountPromise);
    dispatch(AccountsReducer.setOpenAccountSuccess());

  } catch (error) {
    dispatch(AccountsReducer.setOpenAccountFailure(error.response?.data?.data?.descripcionError || error.message));
  }

}


// Clear Open Account Store ====================================================================================================

export const clearAprturaCuentasStore = () => async (dispatch) => {
  dispatch(AccountsReducer.clearOpenAccountStore());
}